'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEdgesCoordinates = exports.getEdgeCoordinates = exports.getRectMidPoints = undefined;

var _pureGraph = require('pure-graph');

var _is = require('is');

var _is2 = _interopRequireDefault(_is);

var _utils = require('utils/utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// get rectangle midpoints, with normal vectors
var getRectMidPoints = exports.getRectMidPoints = function getRectMidPoints(x, y, w, h) {
  return [{ x: x - w / 2, y: y, nx: -1, ny: +0 }, { x: x, y: y + h / 2, nx: +0, ny: +1 }, { x: x + w / 2, y: y, nx: +1, ny: +0 }, { x: x, y: y - h / 2, nx: +0, ny: -1 }];
};

/*
     returns the bezier curve edge coordinates
*/

/* injects from baggage-loader */

var getEdgeCoordinates = exports.getEdgeCoordinates = function getEdgeCoordinates(_ref) {
  var fromX = _ref.fromX;
  var fromY = _ref.fromY;
  var toX = _ref.toX;
  var toY = _ref.toY;
  var fromWidth = _ref.fromWidth;
  var fromHeight = _ref.fromHeight;
  var toWidth = _ref.toWidth;
  var toHeight = _ref.toHeight;

  // get midpoints
  var fromMidPoints = getRectMidPoints(fromX, fromY, fromWidth, fromHeight);
  var toMidPoints = getRectMidPoints(toX, toY, toWidth, toHeight);

  // get closest pair of midpoints
  var closestPair = (0, _utils.getClosestPair)(fromMidPoints, toMidPoints);

  var p1 = closestPair.p1;
  var _closestPair$p = closestPair.p1;
  var startX = _closestPair$p.x;
  var startY = _closestPair$p.y;
  var p2 = closestPair.p2;
  var _closestPair$p2 = closestPair.p2;
  var endX = _closestPair$p2.x;
  var endY = _closestPair$p2.y;

  // calculate direction vectors (for bezier curves)

  var weightedWidth = Math.abs(endX - startX) * 0.5;
  var weightedHeight = Math.abs(endY - startY) * 0.5;

  var startDirX = startX + p1.nx * weightedWidth;
  var startDirY = startY + p1.ny * weightedHeight;

  var endDirX = endX + p2.nx * weightedWidth;
  var endDirY = endY + p2.ny * weightedHeight;

  return { startX: startX, startY: startY, startDirX: startDirX, startDirY: startDirY, endDirX: endDirX, endDirY: endDirY, endX: endX, endY: endY };
};

var getEdgesCoordinates = exports.getEdgesCoordinates = function getEdgesCoordinates(nodeRects, graphData, nodesData) {
  return (0, _pureGraph.getEdges)(graphData).map(function (edge) {
    var fromId = edge.from;
    var toId = edge.to;


    var rectFrom = nodeRects[fromId];
    var rectTo = nodeRects[toId];

    var nodeFrom = nodesData[fromId];
    var nodeTo = nodesData[toId];

    return { edge: edge, rectFrom: rectFrom, rectTo: rectTo, nodeFrom: nodeFrom, nodeTo: nodeTo };
  }).filter(function (_ref2) {
    var rectFrom = _ref2.rectFrom;
    var rectTo = _ref2.rectTo;
    return _is2.default.defined(rectFrom) && _is2.default.defined(rectTo);
  }).map(function (_ref3) {
    var edge = _ref3.edge;
    var nodeFrom = _ref3.nodeFrom;
    var nodeTo = _ref3.nodeTo;
    var rectFrom = _ref3.rectFrom;
    var rectTo = _ref3.rectTo;
    return getEdgeCoordinates({
      edge: edge,
      nodeFrom: nodeFrom,
      nodeTo: nodeTo,
      rectFrom: rectFrom,
      rectTo: rectTo
    });
  });
};


//////////////////
// WEBPACK FOOTER
// ./app/components/Projects/StaticProjectView/utils/computational.js
// module id = 613
// module chunks = 1